import RestResource from '../rest.service';

export default class ProductionDestinationsService extends RestResource {
  constructor() {
    super('production-destinations');
  }
}
